<div class="container">
  <div class="header-row">
    <h2 class="section-title">MEETING NOTES AND ACTIONS</h2>
    @if (canUpload$ | async) {
      <button mat-fab extended class="warn" (click)="openUploadModal()">
        <mat-icon>add</mat-icon>
        ADD NEW
      </button>
    }
  </div>

  <div class="content">
    <ag-grid-angular
      style="width: 100%; height: 65vh"
      [columnDefs]="colDefs"
      [defaultColDef]="defaultColDef"
      [suppressCellFocus]="true"
      (gridReady)="onGridReady($event)"
      [theme]="theme"
      [gridOptions]="gridOptions"
      (cellClicked)="onCellClicked($event)"
    />
  </div>
</div>
